/** Read a shareable cart/checkout voucher code from URL query (?voucher= or ?coupon=). */
export function voucherCodeFromSearchParams(params: {get(name: string): string | null}): string {
  return (params.get("voucher") || params.get("coupon") || "").trim();
}

/** Remove voucher query keys; returns a new URLSearchParams. */
export function stripVoucherQueryParams(params: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(params);
  next.delete("voucher");
  next.delete("coupon");
  return next;
}

/** Build a checkout deep-link that auto-applies the voucher. */
export function checkoutVoucherShareUrl(origin: string, checkoutPath: string, code: string): string {
  const base = origin.replace(/\/$/, "");
  const path = checkoutPath.startsWith("/") ? checkoutPath : `/${checkoutPath}`;
  return `${base}${path}?voucher=${encodeURIComponent(code.trim())}`;
}
